import React, { useState, useEffect } from "react";
import { getWorkersData } from "../../services/service.js";
import "../../assets/css/doctor.scss";
import "../../assets/css/pharmacy.scss";
import { useLocation } from "react-router-dom";

import ListHeader from "../../molecules/ListHeader/ListHeader.js";
import DG from "../../atoms/DataTable/DataGrid.js";
import CustomPagination from "../../atoms/CustomPagination/index.jsx";
import DataGridSkeleton from "../../atoms/DataTable/DataGridSkeleton.js";

const ViewWorker = () => {
  const location = useLocation();
  const projectIdFromRoute = location.state?.projectId;

  const [loader, setLoader] = useState(true);
  const [totalWorker, setTotalWorker] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [workerData, setWorkerData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState(projectIdFromRoute || null);

  const itemsPerPage = 10;

  const handleSearchChange = (data) => {
    const projectId = typeof data === 'object' ? data.project_id : data;
    setSelectedProjectId(projectId || null);
    setCurrentPage(1);
    handleGetData(projectId || null, itemsPerPage, 1);
  };

  const handleGetData = async (id, limit, page, query = "") => {
    setLoader(true);
    try {
      const response = await getWorkersData(
        id || undefined,
        limit,
        page,
        query || undefined
      );
      if (response?.success) {
        setWorkerData(response?.data || []);
        setTotalWorker(response?.pagination?.totalItems || 0);
      } else {
        setWorkerData([]);
        setTotalWorker(0);
      }
    } catch (error) {
      console.error("Error fetching worker data:", error);
      setWorkerData([]);
      setTotalWorker(0);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    const debounceTimer = setTimeout(() => {
      handleGetData(
        selectedProjectId,
        itemsPerPage,
        currentPage,
        searchQuery
      );
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [itemsPerPage, currentPage, searchQuery, selectedProjectId]);

  const handleWorkersSearchChange = (value) => {
    // setSearchQuery(value);
    setSearchQuery(value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="row px-[5px]">
      <div className="col-12">
        <div className="row d-flex align-items-end">
          <div className="col-12">
            <ListHeader
              mainHeading="Worker"
              placeholder="Search"
              btnShow={true}
              linkBreadCrum="/view-worker"
              blinkBreadCrumText="Worker"
              blinkBreadCrumText1="View Worker"
              searchShow={true}
              handleSearchChange={handleSearchChange}
              showLikeFilter={false}
              DropDown={false}
              handleProjectSearchChange={handleWorkersSearchChange}
              searchValue={searchQuery}
              initialProjectId={projectIdFromRoute}
              moduleType="workers"
              showProjectFilter={true}
            />
          </div>
        </div>
      </div>
      <div className="w-full px-2 pt-3">
        {loader ? (
          <DataGridSkeleton
            totalRow={10}
            totalCol={10}
            image={false}
            // header={columns}
          />
        ) : (
          <DG
            key={workerData.length}
            index={4}
            loader={loader}
            data={workerData}
            getData={handleGetData}
          />
        )}
      </div>
      {totalWorker > 0 && (
        <CustomPagination
          totalItems={totalWorker}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}

    </div>
  );
};

export default ViewWorker;
